module.exports = __webpack_public_path__ + "static/media/akashPhoto.ef0cc449.png";